import { URL_Route } from "urlRouts"

export const DashboardMenu = [
    {
        defaultIcon : '/assets/images/icons/dashboard-menu-icons/dashboard.svg',
        activeIcon : '/assets/images/icons/dashboard-menu-icons/dashboard-blue.svg',
        text : 'Dashboard',
        link : URL_Route.Panel,
        id : 'panel'
    },
    {
        defaultIcon : '/assets/images/icons/dashboard-menu-icons/property.svg',
        activeIcon : '/assets/images/icons/dashboard-menu-icons/property-blue.svg',
        text : 'Property List',
        link : URL_Route.Property_List,
        id : 'propertyList'
    },
    {
        defaultIcon : '/assets/images/icons/dashboard-menu-icons/add-property.svg',
        activeIcon : '/assets/images/icons/dashboard-menu-icons/add-property-blue.svg',
        text : 'Add Property',
        link : URL_Route.Add_Property,
        id : 'addProperty'
    },
    {
        defaultIcon : '/assets/images/icons/dashboard-menu-icons/setting.svg',
        activeIcon : '/assets/images/icons/dashboard-menu-icons/setting-blue.svg',
        text : 'Base Info',
        link : URL_Route.Base_Info,
        id : 'baseInfo'
    },
    {
        defaultIcon : '/assets/images/icons/dashboard-menu-icons/sort.svg',
        activeIcon : '/assets/images/icons/dashboard-menu-icons/sort-blue.svg',
        text : 'Region Sort',
        link : URL_Route.Region_Sort,
        id : 'regionSort'
    },
    {
        defaultIcon : '/assets/images/icons/dashboard-menu-icons/add-agent.svg',
        activeIcon : '/assets/images/icons/dashboard-menu-icons/add-agent-blue.svg',
        text : 'Add Agent',
        link : URL_Route.Add_Agent,
        id : 'addAgent'
    },
    {
        defaultIcon : '/assets/images/icons/dashboard-menu-icons/agent-List.svg',
        activeIcon : '/assets/images/icons/dashboard-menu-icons/agent-List-blue.svg',
        text : 'List Agent',
        link :URL_Route.List_Agent,
        id : 'listAgent'
    },
    {
        defaultIcon : '/assets/images/icons/dashboard-menu-icons/about-us.svg',
        activeIcon : '/assets/images/icons/dashboard-menu-icons/about-us-blue.svg',
        text : 'About Us',
        link :URL_Route.About_us,
        id : 'aboutUs'
    },
    {
        defaultIcon : '/assets/images/icons/dashboard-menu-icons/exit.svg',
        activeIcon : '/assets/images/icons/dashboard-menu-icons/exit.svg',
        text : 'LogOut',
        link : URL_Route.Log_Out,
        id : 'logOut'
    },
]